import React, { Component } from 'react';
import styled from 'styled-components';
import { media } from '../../helpers/styleConstants';
import { connect } from 'react-redux';
import moment from 'moment';
import { Checkbox } from 'rmwc/Checkbox';
import { Text } from '../../components/Text';
import { LoadingBar } from '../../components/util/LoadingBar';
import Hint from '../../components/ModuleDrawer/Hint';
import { DynamicWrapper } from '../../components/util/DynamicWrapper';
import { IntRangeSelect } from '../../components/controls/IntRangeSelect';
import { SelectControl } from '../../components/controls/SelectControl';
import { CustomInput } from '../../components/controls/DatePickerControl';
import { Button, Grid, GridCell, Icon, TextField, TextFieldHelperText, Typography } from 'rmwc';
import { backOnboarding, continueOnboarding, pathAware } from '../../actions/onboardingActions';

const MIN_AGE = 50;

const CircularButtonAdd = styled.div`
  height: 28px;
  width: 28px;
  background: #00d29c;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const CircularButtonRemove = styled.div`
  height: 28px;
  width: 28px;
  background: #00d29c;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e0e0e0;
  color: black;
  cursor: pointer;

  ${media.phoneOnly`margin-left: -15px;`};
`;

const AccountRow = styled.div`
  display: flex;
  align-items: flex-start;

  ${media.phoneOnly`
    flex-direction: column;
    justify-content: flex-start;
    padding: 0 15px;
    border: 1px solid #e0e0e0;
  `};
`;

const AccountRowField = styled.div`
  min-width: 22%;

  ${media.phoneOnly`
    width: 95%;
  `};
`;

const circularButtonStyles = {
  height: '25px',
  width: '25px',
  background: '#00d29c',
  color: 'white',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const otherIncomeTypes = [
  {
    type: 'pension',
    label: 'Pension',
  },
  {
    type: 'annuity',
    label: 'Annuity',
  },
  {
    type: 'trustFund',
    label: 'Trust Fund',
  },
];

class OtherRetirementIncomes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      accountNumber: props.qna_hash.pensionAccounts
        ? props.qna_hash.pensionAccounts.answer.length +
          props.qna_hash.annuityAccounts.answer.length +
          props.qna_hash.trustFundAccounts.answer.length
        : 0,
      pension: props.qna_hash.pensionAccounts && !!props.qna_hash.pensionAccounts.answer.length ? true : false,
      pensionAccounts: props.qna_hash.pensionAccounts ? props.qna_hash.pensionAccounts.answer : [],
      annuity: props.qna_hash.annuityAccounts && !!props.qna_hash.annuityAccounts.answer.length ? true : false,
      annuityAccounts: props.qna_hash.annuityAccounts ? props.qna_hash.annuityAccounts.answer : [],
      trustFund: props.qna_hash.trustFundAccounts && !!props.qna_hash.trustFundAccounts.answer.length ? true : false,
      trustFundAccounts: props.qna_hash.trustFundAccounts ? props.qna_hash.trustFundAccounts.answer : [],
    };
  }

  componentDidMount() {
    this.props.pathAware('pensionAccounts');
  }

  componentWillReceiveProps(props) {
    if (props.qna_hash.pensionAccounts) {
      this.setState({
        pension: !!props.qna_hash.pensionAccounts.answer.length,
        pensionAccounts: props.qna_hash.pensionAccounts.answer,
        annuity: !!props.qna_hash.annuityAccounts.answer.length,
        annuityAccounts: props.qna_hash.annuityAccounts.answer,
        trustFund: !!props.qna_hash.trustFundAccounts.answer.length,
        trustFundAccounts: props.qna_hash.trustFundAccounts.answer,
      });
    }
  }

  _onContinue = () => {
    const { onContinue, qna_hash, qna_stack } = this.props;

    this.props
      .continueOnboarding(qna_stack, qna_hash, {
        pensionAccounts: {
          question: 'Will you have other sources of income in retirement (Pension)',
          answer: this.state.pensionAccounts,
        },
        annuityAccounts: {
          question: 'Will you have other sources of income in retirement (Annuity)',
          answer: this.state.annuityAccounts,
        },
        trustFundAccounts: {
          question: 'Will you have other sources of income in retirement (Trust Fund)',
          answer: this.state.trustFundAccounts,
        },
      })
      .then(onContinue);
  };

  _onBack = () => {
    this.props.backOnboarding(this.props.qna_stack).then(this.props.onBack);
  };

  _canContinue = () => {
    const { pensionAccounts, annuityAccounts, trustFundAccounts } = this.state;

    let isFilledIn = true;
    pensionAccounts.forEach(account => {
      Object.keys(account)
        // adjustment and accountNumber/key can be 0
        .filter(key => key !== 'adjustment' && key !== 'key')
        .forEach(key => {
          if (!account[key]) {
            isFilledIn = false;
          }
        });
    });
    return isFilledIn;
  };

  onChange = (evt, field) => {
    this.setState({ [field]: evt.target.checked });
  };

  onChangeTextField = (type, index, evt, field) => {
    const accounts = this.state[`${type}Accounts`].slice();
    accounts[index][field] = evt.target.value;
    this.setState({ [`${type}Accounts`]: accounts });
  };

  // onChangeDatePicker = (type, index, evt, field) => {
  //   const accounts = this.state[`${type}Accounts`].slice();
  //   console.log(evt, 'EVT');
  //   console.log(evt.format(), 'FORMATTED');
  //   accounts[index][field] = evt.format().toString();
  //   this.setState({ [`${type}Accounts`]: accounts });
  // };

  onChangeStartAge = (type, index, evt, field) => {
    const accounts = this.state[`${type}Accounts`].slice();
    let startDate = moment()
      .subtract(this.props.qna_hash.primaryAge.answer, 'years')
      .add(evt.target.value, 'years');

    accounts[index][field] = startDate.format().toString();
    this.setState({ [`${type}Accounts`]: accounts });
  };

  removeAccount = (type, index) => {
    const accounts = this.state[`${type}Accounts`].slice();
    accounts.splice(index, 1);
    this.setState({ [`${type}Accounts`]: accounts });
  };

  incomeCheckbox = option => (
    <Checkbox
      id={option.type}
      className="mr-4"
      key={option.type}
      onChange={e => {
        this.onChange(e, option.type);
      }}
      checked={this.state[option.type]}
      label={option.label}
    />
  );

  accountsSection = option => {
    const accounts = this.state[`${option.type}Accounts`].slice();
    return (
      <div key={`${option.type}AccountsSection`} style={{ width: '100%', borderTop: '1px solid #e0e0e0' }}>
        <div style={{ width: '90%', margin: 'auto' }}>
          <div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
              <Text className="mt-2" use="body2">
                {option.label} Income
              </Text>

              {accounts.map((account, index) => (
                <div
                  key={`${option.type}${account.key}`}
                  style={{ display: 'flex', justifyContent: 'center', width: '100%' }}
                >
                  <AccountRow className="pb-2 mb-2">
                    <AccountRowField className="flow-textfield ml-0 mr-2">
                      <TextField
                        id={`${option.type}${account.key}Nickname`}
                        className="m-0"
                        onChange={e => this.onChangeTextField(option.type, index, e, 'nickname')}
                        value={account.nickname}
                        label="Account Nickname"
                      />
                      <TextFieldHelperText persistent>
                        Give your account a name you can keep track of
                      </TextFieldHelperText>
                    </AccountRowField>
                    <AccountRowField className="flow-textfield ml-0 mr-2">
                      <TextField
                        id={`${option.type}${account.key}MonthlyIncome`}
                        className="m-0"
                        onChange={e => this.onChangeTextField(option.type, index, e, 'monthlyIncome')}
                        value={account.monthlyIncome}
                        label="Monthly Income"
                      />
                      <TextFieldHelperText persistent>The check you expect to receive each month</TextFieldHelperText>
                    </AccountRowField>

                    <AccountRowField className="flow-textfield ml-0 mr-2">
                      <IntRangeSelect
                        id={`${option.type}${account.key}StartAge`}
                        className="m-0"
                        value={
                          moment(account.startDate).year() -
                          moment()
                            .subtract(this.props.qna_hash[`${account.accountOwner}Age`].answer, 'year')
                            .year()
                        }
                        onChange={e => this.onChangeStartAge(option.type, index, e, 'startDate')}
                        label="Age"
                        spec={{
                          field_type: 'range',
                          min:
                            parseInt(this.props.qna_hash[`${account.accountOwner}Age`].answer) > MIN_AGE
                              ? parseInt(this.props.qna_hash[`${account.accountOwner}Age`].answer)
                              : MIN_AGE,
                          max: 80,
                          step_size: 1,
                          _default: parseInt(this.props.qna_hash[`${account.accountOwner}Age`].answer),
                        }}
                      />
                      <TextFieldHelperText persistent>At what age is this income going to start?</TextFieldHelperText>
                    </AccountRowField>

                    {/*<div className="flow-textfield ml-0 mr-2" style={{ width: '130px' }}>
                    <DatePicker
                      id={`${option.type}${account.key}StartDate`}
                      customInput={<CustomInput label="Start Date" />}
                      className="m-0"
                      dateFormat="MM/DD/YYYY"
                      showYearDropdown
                      dropdownMode="select"
                      setDefaultValue={false}
                      onChange={e => this.onChangeDatePicker(option.type, index, e, 'startDate')}
                      selected={moment(account.startDate)}
                    />
                    <TextFieldHelperText className="mb-4" persistent>
                      When income is supposed to start
                    </TextFieldHelperText>
                  </div>

                  <div className="flow-textfield ml-0 mr-2" style={{ width: '120px' }}>
                    <TextField
                      id={`${option.type}${account.key}Adjustment`}
                      className="m-0"
                      onChange={e => this.onChangeTextField(option.type, index, e, 'adjustment')}
                      value={account.adjustment}
                      label="Adjustment"
                    />
                    <TextFieldHelperText className="mb-4" persistent>
                      Annual Inflation adjustment, if any
                    </TextFieldHelperText>
                  </div>*/}

                    {this.props.qna_hash.hasPartner &&
                      this.props.qna_hash.hasPartner.answer && (
                        <AccountRowField className="mr-2 ml-0">
                          <SelectControl
                            id={`${option.type}${account.key}Owner`}
                            style={{ minHeight: '57px' }}
                            label="Account Owner"
                            value={account.accountOwner}
                            spec={{
                              field_type: 'single_choice',
                              options: ['primary', 'partner'],
                              option_data: {
                                primary: { label: 'You' },
                                partner: { label: 'Spouse' },
                              },
                            }}
                            onChange={e => this.onChangeTextField(option.type, index, e, 'accountOwner')}
                          />
                          <TextFieldHelperText persistent>Who does this account belong to?</TextFieldHelperText>
                        </AccountRowField>
                      )}
                  </AccountRow>
                  <div style={{ minWidth: '28px', minHeight: '28px' }}>
                    <CircularButtonRemove onClick={() => this.removeAccount(option.type, index)} className="mr-3 mt-2">
                      <Icon>close</Icon>
                    </CircularButtonRemove>
                  </div>
                </div>
              ))}
            </div>

            {/* Add account button */}
            <div style={{ display: 'flex', justifyContent: 'flex-end' }} className="mb-3">
              <div
                id={`${option.type}AddAccountButton`}
                onClick={() => this.addAccount(option.type)}
                style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
              >
                <Typography className="mb-0" use="subtitle1">
                  <strong>Add new account</strong>
                </Typography>
                <div style={{ minWidth: '28px', minHeight: '28px' }}>
                  <CircularButtonAdd className="ml-3">
                    <Icon>add</Icon>
                  </CircularButtonAdd>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  addAccount = type => {
    // make a copy of accounts
    let accounts = this.state[`${type}Accounts`].slice();
    accounts.push({
      nickname: '',
      monthlyIncome: '',
      startDate:
        this.props.qna_hash.primaryAge.answer < MIN_AGE
          ? moment()
              .add(MIN_AGE - this.props.qna_hash.primaryAge.answer, 'year')
              .format()
              .toString()
          : moment()
              .format()
              .toString(),
      adjustment: 0,
      accountOwner: 'primary',
      key: this.state.accountNumber,
    });
    this.setState({ [`${type}Accounts`]: accounts, accountNumber: this.state.accountNumber + 1 });
  };

  render() {
    const { qna_hash, wrapper } = this.props;
    const { pensionAccounts, annuityAccounts, trustFundAccounts } = this.state;

    if (!qna_hash.hasPartner) {
      return <LoadingBar />;
    }

    return (
      <DynamicWrapper
        style={{ width: '100%' }}
        wrapper={wrapper}
        onContinue={this._onContinue}
        onBack={this._onBack}
        canContinue={this._canContinue()}
        helperText={<Hint>Don't worry about getting it perfect! You'll be able to update this information later</Hint>}
      >
        <div style={{ width: '90%', display: 'flex', justifyContent: 'center' }}>
          <Text use="headline6">Will you have other sources of lifetime income in retirement?</Text>
        </div>
        <div style={{ width: '100%' }}>
          <Text className="ml-4 mr-4" use="body1">
            Click any options that apply and tell us a little more about your income sources. You can leave out Social
            Security&mdash;we will calculate this for you separately.
          </Text>
        </div>
        <div style={{ width: '100%' }}>
          <div style={{ width: '75%', margin: 'auto', display: 'flex', justifyContent: 'space-between' }}>
            {otherIncomeTypes.map(this.incomeCheckbox)}
          </div>
        </div>
        {/* Accounts section */}
        <div style={{ width: '100%' }}>
          {otherIncomeTypes.map(item => this.state[item.type] && this.accountsSection(item))}
        </div>
      </DynamicWrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    qna_hash: state.onboarding.qna_hash,
    qna_stack: state.onboarding.qna_stack,
  };
}

export default connect(mapStateToProps, { backOnboarding, continueOnboarding, pathAware })(OtherRetirementIncomes);
